import { AGENT_HELP } from '../../constants/help_urls';
import HelpLink from '../help_link/help_link';

type Props = {
  message: string;
};

function isDesktopChrome(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const { userAgent } = navigator;

  return (
    userAgent.includes('Chrome') &&
    !userAgent.includes('Edg/') &&
    !userAgent.includes('OPR/') &&
    !userAgent.includes('CriOS')
  );
}

const DownloadAgentErrorMessage = ({ message }: Props) => (
  <div>
    {message}
    {isDesktopChrome() ? (
      <>
        <br />
        Using Chrome? Please check: "Allow local network access" Settings.
      </>
    ) : null}
    <br />
    More information on installing and running the iconik Agent can be found{' '}
    <HelpLink inverted path={AGENT_HELP} text="here" />
  </div>
);

export default DownloadAgentErrorMessage;
